"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("../../styles/common.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/jsx-indent-props, react/jsx-closing-bracket-location */
var TextBlock = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(TextBlock, _React$Component);
  function TextBlock() {
    _classCallCheck(this, TextBlock);
    return _callSuper(this, TextBlock, arguments);
  }
  _createClass(TextBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        field = _this$props.field,
        type = _this$props.type,
        comment = _this$props.comment,
        showErrorsImmediately = _this$props.showErrorsImmediately,
        isWysiwyg = _this$props.isWysiwyg,
        wysiwygProps = _this$props.wysiwygProps,
        size = _this$props.size,
        placeholder = _this$props.placeholder,
        inputStyle = _this$props.inputStyle;
      var label = this.props.label ? /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, this.props.label) : null;
      var sizeClass = 'form-group-' + size;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'form-group ' + sizeClass + ' ' + ((field.touched || showErrorsImmediately) && field.error ? 'has-error' : '')
      }, label, comment && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].comment
      }, comment), !isWysiwyg ? /*#__PURE__*/_react["default"].createElement("input", _extends({
        placeholder: placeholder,
        className: "form-control",
        style: inputStyle
      }, (0, _domOnlyProps["default"])(field), {
        type: type
      })) : /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], _extends({
        type: "input"
      }, wysiwygProps, {
        content: field.value,
        onChange: field.onChange,
        style: inputStyle
      })), (field.touched || showErrorsImmediately) && field.error && /*#__PURE__*/_react["default"].createElement("div", {
        className: "help-block"
      }, field.error));
    }
  }]);
  return TextBlock;
}(_react["default"].Component);
_defineProperty(TextBlock, "propTypes", {
  field: _propTypes["default"].object.isRequired,
  type: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  placeholder: _propTypes["default"].string,
  comment: _propTypes["default"].node,
  showErrorsImmediately: _propTypes["default"].bool,
  isWysiwyg: _propTypes["default"].bool,
  wysiwygProps: _propTypes["default"].object,
  size: _propTypes["default"].string,
  inputStyle: _propTypes["default"].object
});
_defineProperty(TextBlock, "defaultProps", {
  label: null,
  type: 'text',
  placeholder: '',
  showErrorsImmediately: true,
  isWysiwyg: false,
  wysiwygProps: {},
  // Options: 'sm', 'md', 'lg'
  size: 'sm',
  inputStyle: {}
});